export function hrefReplace(text: string): string {
    // const RexpWww = /((?<!\/)www[\w?=&.\/-;#~%-]+(?![\w\s?&.\/;#~%"=-]*>))/g;
    const RexpWww = /(www[\w?=&.\/-;#~%-]+(?![\w\s?&.\/;#~%"=-]*>))/g;
    const textWww = text ? text.replace(RexpWww, 'https://$1') : '';
    const RexpHttp = /(((http|https|ftp):\/\/)[\w?=&.\/-;#~%-]+(?![\w\s?&.\/;#~%"=-]*>))/g;

    return textWww ? textWww.replace(RexpHttp, '<a href="$1" target="_blank" class="h-link">$1</a>') : '';
}